import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import moment from 'moment';
import MomentLocaleUtils from 'react-day-picker/moment';
import DayPicker, { DateUtils } from 'react-day-picker';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { toTimezone } from '../../utils/dates';

import './date-picker.css';

function selectedDaysHandler(selected, day) {
  return DateUtils.isSameDay(selected, day);
}

function generateHoursList(date, timezone = 'UTC', startHour = 0) {
  timezone = timezone || 'UTC';
  const jsDate = new Date(date);
  const localizedDate = toTimezone(jsDate, timezone);

  return [...Array(24).keys()].map((el, i) => {
    const momentValue = localizedDate
      .startOf('day')
      .add(localizedDate.get('minute'), 'minute')
      .add(i, 'hour');

    return {
      value: momentValue.toISOString(),
      title: momentValue.format('HH')
    };
  }).slice(startHour, 24);
}

function generateMinutesList(date, timezone = 'UTC') {
  timezone = timezone || 'UTC';
  const jsDate = new Date(date);
  const localizedDate = toTimezone(jsDate, timezone);

  return [...Array(6).keys()].map((el, i) => {
    const momentValue = localizedDate
      .startOf('hour')
      .add(i * 10, 'minute');

    return {
      value: momentValue.toISOString(),
      title: momentValue.format('mm')
    };
  });
}

class DatePicker extends PureComponent {
  render() {
    const {
      dayPickerOpened,
      toggleDayPicker,
      label,
      timeChangeHandler,
      dayChangeHandler,
      dateTimeValue,
      timezone,
      disabledDays,
      disabled
    } = this.props;

    const dateTimeMoment = toTimezone(new Date(dateTimeValue), timezone);

    let beforeDate;
    let startHour = 0;

    if (disabledDays) {
      const { before } = disabledDays;
      beforeDate = toTimezone(before, timezone);

      if (beforeDate.year() === dateTimeMoment.year() &&
          beforeDate.month() === dateTimeMoment.month() &&
          beforeDate.date() === dateTimeMoment.date()) {

        startHour = beforeDate.hour();
      }
    }

    return (
      <FormGroup className="clearfix date-time-form-group">
        {label &&
          <ControlLabel>{label}</ControlLabel>
        }

        <div className="day-picker-container">
          <FormControl
            readOnly
            type="text"
            value={dateTimeMoment.format('DD/MM/YYYY')}
            onClick={toggleDayPicker}
            disabled={disabled}
          />

          {(dayPickerOpened) &&
            <DayPicker
              className="day-picker"
              enableOutsideDays={true}
              localeUtils={MomentLocaleUtils}
              locale={this.props.i18n.language}
              selectedDays={selectedDaysHandler.bind(null, moment(dateTimeMoment.format('YYYY-MM-DD')).toDate())}
              onDayClick={dayChangeHandler}
              disabledDays={this.props.disabledDays}
            />
          }
        </div>

        <div className="time-picker-container">
          <Dropdown id="hoursSelectSelect" disabled={disabled}>
            <Dropdown.Toggle noCaret>
              {dateTimeMoment.format('HH')}
              <span className="dropdown-toggle-icon">
                <span className="caret" />
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {generateHoursList(dateTimeMoment.toISOString(), timezone, startHour).map(el =>
                <MenuItem
                  key={el.value}
                  eventKey={el.value}
                  active={dateTimeMoment.toISOString() === el.value}
                  onClick={() => timeChangeHandler(el.value)}
                >
                  {el.title}
                </MenuItem>
              )}
            </Dropdown.Menu>
          </Dropdown>

          {' : '}

          <Dropdown id="minutesSelectSelect" disabled={disabled}>
            <Dropdown.Toggle noCaret>
              {dateTimeMoment.format('mm')}
              <span className="dropdown-toggle-icon">
                <span className="caret" />
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {generateMinutesList(dateTimeMoment.toISOString(), timezone).map(el =>
                <MenuItem
                  key={el.value}
                  eventKey={el.value}
                  active={dateTimeMoment.toISOString() === el.value}
                  onClick={() => timeChangeHandler(el.value)}
                >
                  {el.title}
                </MenuItem>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </FormGroup>
    );
  }
}

DatePicker.propTypes = {
  dayPickerOpened: PropTypes.bool.isRequired,
  toggleDayPicker: PropTypes.func.isRequired,
  label: PropTypes.string,
  timeChangeHandler: PropTypes.func.isRequired,
  dayChangeHandler: PropTypes.func.isRequired,
  dateTimeValue: PropTypes.any,
  timezone: PropTypes.string,
  disabledDays: PropTypes.any
};

export default translate(['translations'])(DatePicker);



// WEBPACK FOOTER //
// ./src/widgets/DatePicker/index.jsx